import {ReactElement} from 'react'
import CloseIcon from '@material-ui/icons/Close'
import {Trans} from 'react-i18next'

import {ClientType, Maybe, ClientBankDetails} from '../../../../../../graphql/types'
import {ModalContainer} from '../../ModalContainer'
import messages from '../../../../../../assets/messages'
import {WithdrawalMethodValues} from '../../constants'
import {BankTransferFields} from './BankTransferFields'
import {CryptoFields} from './CryptoFields'
import {PayRetailerFields} from './PayRetailerFields'
import {PixPayoutFields} from './PixPayoutFields'
import {
  CRYPTO_NETWORK_OPTIONS,
  CRYPTO_PAYOUT_NETWORK_OPTIONS,
  CRYPTO_DFNS_PAYOUT_NETWORK_OPTIONS,
} from './constants'
import {useStyles} from './styles'

type WithdrawalMethodModalProps = {
  addPayoutTypeModalOpen: WithdrawalMethodValues | boolean
  bankTransferPaymentFields: Record<string, any> | null
  clientBankDetails: ClientBankDetails | null
  onBankTransferSet: (fieldValues) => void
  cryptoPaymentFields: Record<string, any> | null
  onCryptoSet: (fieldValues) => void
  cryptoPayoutPaymentFields: Record<string, any> | null
  onCryptoPayoutSet: (fieldValues) => void
  dfnsCryptoPayoutPaymentFields: Record<string, any> | null
  onDfnsCryptoPayoutSet: (fieldValues) => void
  payRetailersPaymentFields: Record<string, any> | null
  onPayRetailersSet: (fieldValues) => void
  pixPayoutPaymentFields: Record<string, any> | null
  onPixPayoutSet: (fieldValues) => void
  clientType: Maybe<ClientType>
  passportNumber: Maybe<string>
  onClose: () => void
}

function WithdrawalMethodModal(props: WithdrawalMethodModalProps): ReactElement {
  const classes = useStyles()
  const {
    addPayoutTypeModalOpen,
    bankTransferPaymentFields,
    clientBankDetails,
    onBankTransferSet,
    cryptoPaymentFields,
    onCryptoSet,
    cryptoPayoutPaymentFields,
    onCryptoPayoutSet,
    dfnsCryptoPayoutPaymentFields,
    onDfnsCryptoPayoutSet,
    payRetailersPaymentFields,
    onPayRetailersSet,
    pixPayoutPaymentFields,
    onPixPayoutSet,
    clientType,
    passportNumber,
    onClose,
  } = props

  return (
    <ModalContainer isOpen={Boolean(addPayoutTypeModalOpen)} onClose={onClose}>
      <div className={classes.content}>
        <div className={classes.header}>
          <CloseIcon className={classes.closeIcon} onClick={onClose} />
          <div className={classes.title}>
            <Trans {...messages.addPayoutAccount} />
          </div>
          <div className={classes.subtitle}>
            <Trans {...messages.enterYourPaymentDetails} />
          </div>
        </div>
        <div className={classes.body}>
          {addPayoutTypeModalOpen === WithdrawalMethodValues.bankTransfer ? (
            <BankTransferFields
              bankTransferPaymentFields={bankTransferPaymentFields}
              clientBankDetails={clientBankDetails}
              onBankTransferSet={onBankTransferSet}
              onClose={onClose}
            />
          ) : null}
          {addPayoutTypeModalOpen === WithdrawalMethodValues.cryptocurrency ? (
            <CryptoFields
              networkOptions={CRYPTO_NETWORK_OPTIONS}
              cryptoPaymentFields={cryptoPaymentFields}
              onCryptoSet={onCryptoSet}
              onClose={onClose}
            />
          ) : null}
          {addPayoutTypeModalOpen === WithdrawalMethodValues.enovipayCryptoPayout ? (
            <CryptoFields
              networkOptions={CRYPTO_PAYOUT_NETWORK_OPTIONS}
              cryptoPaymentFields={cryptoPayoutPaymentFields}
              onCryptoSet={onCryptoPayoutSet}
              onClose={onClose}
            />
          ) : null}
          {addPayoutTypeModalOpen === WithdrawalMethodValues.dfnsCryptoPayout ? (
            <CryptoFields
              networkOptions={CRYPTO_DFNS_PAYOUT_NETWORK_OPTIONS}
              cryptoPaymentFields={dfnsCryptoPayoutPaymentFields}
              onCryptoSet={onDfnsCryptoPayoutSet}
              onClose={onClose}
            />
          ) : null}
          {addPayoutTypeModalOpen === WithdrawalMethodValues.enovipayPixPayout ? (
            <PixPayoutFields
              paymentFields={pixPayoutPaymentFields}
              onPaymentMethodSet={onPixPayoutSet}
              clientType={clientType}
              customerIdentity={passportNumber}
              onClose={onClose}
            />
          ) : null}
          {addPayoutTypeModalOpen === WithdrawalMethodValues.payRetailers ? (
            <PayRetailerFields
              payRetailersPaymentFields={payRetailersPaymentFields}
              onPayRetailersSet={onPayRetailersSet}
              onClose={onClose}
            />
          ) : null}
        </div>
      </div>
    </ModalContainer>
  )
}

export {WithdrawalMethodModal}
